/* eslint-disable import/prefer-default-export */
export const SET_PRODUCT_DATA = 'setProductData';
export const SET_PAGE_UTAG_DATA = 'setPageUtagData';
export const SET_SLIDEOUT = 'setSlideout';
export const BACK_SLIDEOUT = 'backToPreviousSlideout';
export const SET_REVIEWS = 'setReviews';
export const SET_REVIEWS_PAGE_NUMBER = 'setReviewsPageNumber';
export const SET_REVIEWS_TOTAL_RESULTS = 'setReviewsTotalResults';
export const SET_REVIEWS_CURRENT_RESULTS = 'setReviewsCurrentResults';
export const SET_REVIEWS_LOADING_STATE = 'setReviewsLoadingState';
export const SET_REVIEWS_STAR_FILTERING = 'setReviewsStarFiltering';
export const SET_REVIEWS_SORT_BY = 'setReviewsSortBy';
export const SET_REVIEWS_FREQUENTLY_MENTIONED = 'setReviewsFrequentlyMentioned';
export const SET_REVIEWS_SELECTED_FREQUENTLY_MENTIONED = 'setReviewsSelectedFrequentlyMentioned';
export const SET_REVIEWS_STATISTICS = 'setReviewsStatistics';
export const SET_REVIEWS_PHOTOS = 'setReviewsPhotos';
export const SET_REVIEWS_SEARCH_QUERY = 'setReviewsSearchQuery';
export const UPDATE_HEADER = 'updateReviewsHeader';
export const UPDATE_IS_FILTERED = 'updateIsFiltered';
export const SET_IS_SUBMITTING_REVIEW = 'setIsSubmittingReview';
export const SET_SHOW_SUBMITTING_ERROR = 'setShowSubmittingError';
export const SET_ID_QUANTITY_MAP = 'setIdQuantityMap';
export const SET_IS_CURRENT_PRODUCT_REVIEWED = 'setIsCurrentProductReviewed';
export const SET_IS_CONDENSED = 'setIsCondensed';
export const SET_GENERATED_SUMMARY = 'setGeneratedSummary';
